define.alias("shared/utils/string-formatters/remove-underscores", "settings/utils/string-formatters/remove-underscores");